// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"454":"c53385c7","465":"d4c0f91f","616":"39743c3f"}[chunkId] + ".chunk.css";
};